import styled from '@emotion/styled';

export const SvgContainer = styled.svg`
  display: none;
`;
